import React  from 'react';
import ShImage from "../../components/image/shImage";
import style from "./shBlogCard.module.scss";
import ChevronRightSVG from "public/icons/chevronRight.svg";
import Link from "next/link";
import { shTimePipe } from "../../helper/pipes/time-pipe";

const ShBlogCard = ( { blog, className = "", shortVersion = false, newestBlogId }: any ) => {

    if(!blog){
        return null;
    }

    return (
        <Link href={"/blog/" + blog.slug} legacyBehavior>
            <div className={style.blogCard + " c-pointer shadow card-hover border-radius p-relative " + className}>

                {blog.id === newestBlogId &&
                    <div className={style.newestBadge}>
                        <div className="badge">
                            Neu
                        </div>
                    </div>
                }
                <div className={style.img}>
                    <ShImage url={blog.headerImage?.url} fullHeight={true} coverFit={true} fullWidth={true}/>
                    {blog.ReadingTime &&
                        <>
                            <p className="small-text text-white">Lesezeit: {shTimePipe(blog.ReadingTime)}</p>
                            <div className={style.background} />
                        </>
                    }
                </div>
                <div className={style.blogInfo + " p-3"}>
                    <p className={"h6"}>{blog.title}</p>
                    <p className={"strong opacity-50"}>{blog.subTitle}</p>

                    {!shortVersion &&
                        <div className={style.content}>
                            <p className={"mt-2"}>{blog.SEODescription}</p>
                            <div className="d-flex justify-items-center align-items-center mt-2">
                                <p className={"text-lobster small-text"}>zum Beitrag ...</p>
                                <ChevronRightSVG className="svg-lobster svg-small"/>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </Link>
    );
};

export default ShBlogCard;
